import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AbHealthBaseObjFactory;
/* eslint-disable */
/**
 * Health
 * Ab Initio Health Services
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/health.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * Base health status object.
 * @export
 * @interface AbHealthBaseObj
 */

export class AbHealthBaseObjFactory {}
_AbHealthBaseObjFactory = AbHealthBaseObjFactory;
_defineProperty(AbHealthBaseObjFactory, "FromJSON", function (json) {
  return _AbHealthBaseObjFactory.FromJSONTyped(json, false);
});
_defineProperty(AbHealthBaseObjFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'status': json['status'],
    'message': json['message']
  };
});
_defineProperty(AbHealthBaseObjFactory, "ToJSON", function (value) {
  return _AbHealthBaseObjFactory.ToJSONTyped(false, value);
});
_defineProperty(AbHealthBaseObjFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'status': value.status,
    'message': value.message
  };
});
//# sourceMappingURL=AbHealthBaseObj.js.map
